"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
/* eslint-disable react-hooks/rules-of-hooks */
const react_1 = tslib_1.__importDefault(require("react"));
const react_2 = require("@osmosys/react");
const ButtonContainer_1 = require("../ButtonContainer");
const useHideButtonText_1 = require("./hooks/useHideButtonText");
exports.EmailCanvasBlockHideButton = ({ contentCanBeChanged, updateBlock, hidden, hideable, disabled, showOverlay, showOnOverlay = false, }) => {
    if (!hideable) {
        return null;
    }
    const text = useHideButtonText_1.useHideButtonText(showOnOverlay, hidden);
    disabled =
        (showOverlay && !showOnOverlay) ||
            disabled ||
            !hideable ||
            (!hidden && !contentCanBeChanged);
    return (react_1.default.createElement(ButtonContainer_1.ButtonContainer, { noMargin: showOnOverlay },
        react_1.default.createElement(react_2.OsmosysButton, { disabled: disabled, blurOnClick: true, onClick: () => {
                if (disabled) {
                    return;
                }
                updateBlock({
                    hidden: !hidden,
                });
            }, osysStyle: showOnOverlay ? 'blockOverlay' : 'blockToolbar', tooltip: hidden ? 'Show block' : 'Hide block', osysIcon: hidden ? 'show' : 'hide', osysName: hidden
                ? 'EmailCanvasBlockHideButton.show'
                : 'EmailCanvasBlockHideButton.hide' }, text)));
};
//# sourceMappingURL=HideButton.js.map